import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ordersPathTo } from '../utils/Api';
import OrderCard from "./OrderCard";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const limit = 5; // Limite de 5 pedidos por página
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        // Assumindo que a API aceita limit e offset
        const result = await ordersPathTo.list({ limit, offset });
        const newOrders = result.data.orders || result.data; // Ajuste conforme a estrutura da resposta
        const total = result.data.count || result.data.length; // Total de pedidos

        // Adiciona novos pedidos à lista existente
        setOrders((prevOrders) => [...prevOrders, ...newOrders]);

        setIsLoading(false);

        // Verifica se há mais pedidos para carregar
        setHasMore(offset + limit < total);
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
      }
    };

    fetchOrders();
  }, [offset]);

  const handleLoadMore = () => {
    setOffset((prevOffset) => prevOffset + limit);
  };

  if (isLoading) {
    return (
      <Box mt={2}>
        <Typography variant="p">
          <b>Carregando...</b>
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography mt={2} color="primary" variant="h5">
        <b>Meus Pedidos</b>
      </Typography>
      {orders.length === 0 && (
        <Box mt={2}>
          <Typography variant="p">
            Você ainda não fez nenhum pedido
          </Typography>
        </Box>
      )}
      {orders.length > 0 && (
        <Box>
          {orders.map((order) => (
            <OrderCard
              key={order.id}
              order={order}
              handleCardClick={() => navigate('/orders/' + order.id)}
            />
          ))}
          {hasMore && (
            <Box mt={2} display="flex" justifyContent="center">
              <Button variant="contained" color="primary" onClick={handleLoadMore}>
                Ver mais
              </Button>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default MyOrders;